import { ref } from "vue";

const backendUrl = process.env.VUE_APP_BACKEND_URL;

let user = ref(null);
export { user };

export async function getUser() {
    // If the user is logged in,
    // the cookie ticp_session should be already set to a valid TICP session,
    // which is further verified by the backend
    const url = new URL(`${backendUrl}/auth_user`);
    try {
        const response = await fetch(url.toString(), {credentials: "include"});
        user.value = await response.json();
        console.log(`${url} returned`, user.value);
        return user.value;
    } catch (error) {
        console.error(`${url} thrown ${error}`);
        return null;
    }
}

export async function getMerchants() {
    const url = new URL(`${backendUrl}/merchants`);
    const response = await fetch(url.toString(), {credentials: "include"});
    return await response.json();
}
